<!--
  ~ Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<p-multiselect
  appendTo='body'
  scrollHeight='300px'
  [style]="{width: '100%'}"
  [showClear]='true'
  [placeholder]='translationSchema.utils.search | translate'
  [options]="options() | translateSelectItems : {translatePath : ''}"
  [ngModel]='value()'
  [attr.data-testid]='dataCy() || null'
  (ngModelChange)='search($event)' data-testid="value-multiselect">
</p-multiselect>


